<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form #ta="ngForm" class="formborder">
    <div class="col-md-12 row my-2" style="display: flex; align-items: center">
      <div class="col-md-2">
        <label class="required-lable" for="DueFromDate">From Date</label>

        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker1"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="FromDate"
            id="FromDate"
            required
            #ref_due_from="ngModel"
            class="form-control input-text-css"
            [(ngModel)]="FromDate"
            [ngClass]="{
              'is-invalid': ta.submitted && ref_due_from.invalid,
              'alert-warning':
                ref_due_from.invalid &&
                (ref_due_from.dirty ||
                  ref_due_from.touched ||
                  ref_due_from.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2">
        <label class="required-lable" for="DateTo">To Date</label>
        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker2"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="ToDate"
            id="ToDate"
            required
            [min] = "FromDate"
            #ref_due_to="ngModel"
            class="form-control input-text-css"
            [(ngModel)]="ToDate"
            [ngClass]="{
              'is-invalid': ta.submitted && ref_due_to.invalid,
              'alert-warning':
                ref_due_to.invalid &&
                (ref_due_to.dirty ||
                  ref_due_to.touched ||
                  ref_due_to.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
        </div>

     <div class="col-md-2">
        <div>&nbsp;</div>
        <button
          class="mt-2 btn font-size-12 button-btn"
          (click)="onsearchemidetails()"
          [disabled]="ta.form.invalid"
        >
          Search
        </button>
      </div>
      <div class="col-md-4 mt-3">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>


<div class="row mt-3"   [hidden]="!DataSource">
  <div class="col-md-12" >
    <div class="table-responsive" >
      <mat-table 
        class="table-bordered table-striped"
        matSort
        [dataSource]="DataSource"
        style="overflow: auto; height: fit-content; max-width: 100%"
      >
        <ng-container matColumnDef="#">
          <mat-header-cell mat-sort-header *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index">
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Application_No">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Application No</mat-header-cell
          >
          <mat-cell *matCellDef="let row">{{ row.Application_No }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container> 

        <ng-container matColumnDef="LoanAcNo">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >LoanAcNo</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.LoanAcNo }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Customer_Name">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Customer Name</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.Customer_Name }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Branch_Name">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Branch Name</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.Branch_Name }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Product_Name">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Product Name</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.Product_Name }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef style="font-weight: bold;">Total</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="OpeningBalance">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Opening</mat-header-cell
          >
          <mat-cell *matCellDef="let row"
          style="text-align: center">
            {{ row.OpeningBalance | number:'1.2-2' }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef style="text-align: center; font-weight: bold;">
            {{ totaltypewise('OpeningBalance') | number:'1.2-2' }}
          </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="AdditionalBalance">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Addition</mat-header-cell
          >
          <mat-cell *matCellDef="let row"
          style="text-align: center">
            {{ row.AdditionalBalance | number:'1.2-2' }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef style="text-align: center; font-weight: bold;">
            {{ totaltypewise('AdditionalBalance') | number:'1.2-2' }}
          </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="ReceivedBalance">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Recovered</mat-header-cell
          >
          <mat-cell *matCellDef="let row"
          style="text-align: center">
            {{ row.ReceivedBalance | number:'1.2-2' }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef style="text-align: center; font-weight: bold;">
            {{ totaltypewise('ReceivedBalance') | number:'1.2-2' }}
          </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="ClosingBalance">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Closing</mat-header-cell
          >
          <mat-cell *matCellDef="let row"
          style="text-align: center">
            {{ row.ClosingBalance | number:'1.2-2' }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef style="text-align: center; font-weight: bold;">
            {{ totaltypewise('ClosingBalance') | number:'1.2-2' }}
          </mat-footer-cell>
        </ng-container>

    <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          class="sticky-footer fontcolor"
          style="background: #4dc3a3;line-height: 1.5 !important;"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns; let i = index"
          
        ></mat-row>
        <mat-footer-row
          class="sticky-footer fontcolor"
          *matFooterRowDef="displayedColumns; sticky: true"
          style="background: #4dc3a3"
        ></mat-footer-row>
      </mat-table>
    </div>
    <div class="row m-0 ml-3">
     
      <div class="col-md-8 mt-2">
        <mat-paginator
          #paginatorRef
          [pageSizeOptions]="[20, 50]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </div>
  </div> 
   <div class="col-md-4 mt-2">
        <button
          class="mt-3 btn font-size-12 button-btn"
          (click)="exportTable(exporter)"
        >
          <i
            class="fa fa-file-export mr-1"
            style="font-size: medium; cursor: pointer"
          ></i>
          Export
        </button>
      </div>
</div>

<div style="height: 0; width: 0; position: absolute; overflow: hidden; top: -9999px; left: -9999px;">
  <mat-table 
    [dataSource]="ExportDataSource"
    matTableExporter
    #exporter="matTableExporter"
  >
    <ng-container matColumnDef="#">
      <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Application_No">
      <mat-header-cell *matHeaderCellDef>Application No</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Application_No }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container> 

    <ng-container matColumnDef="LoanAcNo">
      <mat-header-cell *matHeaderCellDef>LoanAcNo</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.LoanAcNo }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Customer_Name">
      <mat-header-cell *matHeaderCellDef>Customer Name</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Customer_Name }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Branch_Name">
      <mat-header-cell *matHeaderCellDef>Branch Name</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Branch_Name }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Product_Name">
      <mat-header-cell *matHeaderCellDef>Product Name</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Product_Name }}</mat-cell>
      <mat-footer-cell *matFooterCellDef>Total</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="OpeningBalance">
      <mat-header-cell *matHeaderCellDef>Opening</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.OpeningBalance | number:'1.2-2' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef>{{ totaltypewise('OpeningBalance') | number:'1.2-2' }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="AdditionalBalance">
      <mat-header-cell *matHeaderCellDef>Addition</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.AdditionalBalance | number:'1.2-2' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef>{{ totaltypewise('AdditionalBalance') | number:'1.2-2' }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="ReceivedBalance">
      <mat-header-cell *matHeaderCellDef>Recovered</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.ReceivedBalance | number:'1.2-2' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef>{{ totaltypewise('ReceivedBalance') | number:'1.2-2' }}</mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="ClosingBalance">
      <mat-header-cell *matHeaderCellDef>Closing</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.ClosingBalance | number:'1.2-2' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef>{{ totaltypewise('ClosingBalance') | number:'1.2-2' }}</mat-footer-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
  </mat-table>
</div>
